import { Observable } from 'rxjs/Observable'
import * as actions from './actions'
import { api } from './api'
import { combineEpics } from 'redux-observable'
import { getUserID } from './selectors'
import { VIEWED_MM_MODAL_ON_KB } from "../../constants";
import { map, startWith, catchError } from 'rxjs/operators'

const patchUserProperties = (action$, store) => {
  return action$
    .ofType(actions.patchUserProperties.toString())
    .mergeMap(() => {
      const properties = {
        [VIEWED_MM_MODAL_ON_KB]: true
      }
      const userId = getUserID(store.getState())

      return api
        .patchUserProperties(userId, properties)
        .pipe(
          map(actions.patchUserPropertiesSuccess),
          startWith(actions.patchUserPropertiesPending()),
          catchError(() => Observable.of(actions.patchUserPropertiesFailed()))
        )
    })
}

export const epic = combineEpics(patchUserProperties)